import * as CryptoJS from 'crypto-js'

let _key = 'secret_key'

const encrypt = (txt = '', key = _key) => {
  return CryptoJS.AES.encrypt(txt, key).toString()
}

const decrypt = (txtToDecrypt = '', key = _key) => {
  return (
    CryptoJS.AES.decrypt(txtToDecrypt, key).toString(CryptoJS.enc.Utf8) || []
  )
}

export { encrypt, decrypt }
